export default "__VITE_ASSET__BfgLeYW5__"